var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"my-0"},[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_vm._t("form")],2),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_vm._t("text")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }